export const defaultLocale = "en";
export const minPartialPaymentInCents = 500;

export const consumerAppBaseUrl = import.meta.env.VITE_CONSUMER_APP_API_URL;
export const flexBaseUrl = import.meta.env.VITE_FLEX_API_URL;
export const springBaseUrl = import.meta.env.VITE_SPRING_API_URL;
export const weglotToken = import.meta.env.VITE_WEGLOT_TOKEN;

export const BounceAddressDetails = {
  street_line_1: "333 Metro Park",
  street_line_2: "S-205",
  city: "Rochester",
  state: "New York",
  zipcode: "14623",
  phone_numbers: ["+18884825060"],
  fax_numbers: ["818.503.1961"],
};
